import { CategoryButton, Grid } from '../../Molecules'
import { LeksikonDirectoryWithIconProps } from './props'

const LeksikonDirectoryWithIcon = ({
    buttons,
}: LeksikonDirectoryWithIconProps) => {
    const categoryButtons = buttons.map((btn, i) => (
        <CategoryButton
            icon={btn.icon}
            text={btn.text}
            variant="squaredButton"
            key={i}
            onClick={btn.onClick}
            css={{
                fontSize: 14,
            }}
        />
    ))

    return (
        <Grid
            autoFlow="dense"
            gap={16}
            css={{
                gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
            }}
        >
            {categoryButtons}
        </Grid>
    )
}

export default LeksikonDirectoryWithIcon
